import { TypographyOptions } from '@mui/material/styles/createTypography';

const mainTypographies = {
  h1: {
    fontWeight: 400,
    fontSize: '3rem',
    lineHeight: '3.5rem',
    textTransform: 'capitalize',
  },
  h2: {
    fontWeight: 400,
    fontSize: '2.5rem',
    lineHeight: '3rem',
    textTransform: 'capitalize',
  },
  h3: {
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: '2.375rem',
    textTransform: 'capitalize',
  },
  h4: {
    fontWeight: 700,
    fontSize: '1.75rem',
    lineHeight: '2.25rem',
    textTransform: 'capitalize',
  },
  h5: {
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: '2rem',
    textTransform: 'capitalize',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1.375rem',
    textTransform: 'capitalize',
    lineHeight: '1.75rem',
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: '1.625rem',
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: '1rem',
    letterSpacing: '0.0125rem',
    lineHeight: '1.5rem',
  },
  body1: {
    fontWeight: 400,
    fontSize: '1rem',
    letterSpacing: '0.0125rem',
    lineHeight: '1.5rem',
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.875rem',
    letterSpacing: '0.01875rem',
    lineHeight: '1.375rem',
  },
  button: {
    fontWeight: 600,
    fontSize: '0.875rem',
    textTransform: 'none',
    letterSpacing: '0.0125rem',
    lineHeight: '1.25rem',
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'none',
    letterSpacing: '0.015625rem',
    lineHeight: '1rem',
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.6875rem',
    letterSpacing: '0.01875rem',
    lineHeight: '1rem',
  },
  h1Custom: {
    fontFamily: 'Michroma',
    fontSize: '2.5rem',
    fontWeight: 400,
  }
} as const;

const createBoldTypography = (typographyRules: Record<string, string | number>) => {
  return {
    ...typographyRules,
    fontWeight: 700,
    fontFamily: 'Lato',
  };
};

const boldTypographies = {
  h6Bold: createBoldTypography(mainTypographies.h6),
  subtitle1Bold: createBoldTypography(mainTypographies.subtitle1),
  subtitle2Bold: createBoldTypography(mainTypographies.subtitle2),
  body1Bold: createBoldTypography(mainTypographies.body1),
  body2Bold: createBoldTypography(mainTypographies.body2),
  captionBold: createBoldTypography(mainTypographies.caption),
  overlineBold: createBoldTypography(mainTypographies.overline),
};

const typographyOptions: TypographyOptions = {
  fontFamily: 'Lato',
  ...mainTypographies,
  ...boldTypographies,
};

export default typographyOptions;